import { useEffect, useState } from 'react';

import {
  hasUnreadTask,
  TASKS_PENDING_APPROVAL_MODAL_ID,
} from 'components/tasks-pending-approval-participants-modal/read-notifications';
import { useModal } from 'context/ModalContext';
import { getTasksPendingApprovalParticipants } from 'services/dashboard.service';

import { canApproveParticipants, PlayerProfile } from './home-reads';

/**
 * Participações aguardando a aprovação do gestor de equipe, nos blocos de ciclo aberto e fechado.
 * O aviso abre sozinho quando alguma ainda não foi vista (FECH-07, FECH-08).
 */
export function usePendingParticipantApprovals(userInfo?: PlayerProfile | null) {
  const { showModal } = useModal();
  const [tasks, setTasks] = useState<any[]>();

  const playerId = userInfo?.chave;
  const canApprove = canApproveParticipants(userInfo);

  // Só primitivos: nova referência de `userInfo` (refreshUser) não refaz a leitura.
  useEffect(() => {
    if (!playerId || !canApprove) return;

    let active = true;

    getTasksPendingApprovalParticipants()
      .then(pending => {
        if (active) setTasks(pending);
      })
      .catch(error => console.error('Erro ao carregar as participações aguardando aprovação:', error));

    return () => {
      active = false;
    };
  }, [playerId, canApprove]);

  useEffect(() => {
    if (Array.isArray(tasks) && tasks.length && hasUnreadTask(tasks)) {
      showModal(TASKS_PENDING_APPROVAL_MODAL_ID);
    }
  }, [showModal, tasks]);

  return tasks;
}
